module.exports = __webpack_public_path__ + "img/comparison.36dfb6a7.jpg";